
<template>
    <div>
        <div class='row justify-center full-width q-pa-md'>
            <q-tabs class='full-width' inverted color="primary" animated>
                <!-- Tabs - notice slot="title" -->
                <q-tab default slot="title" name="tab-1" icon="fas fa-chart-line"  label='Общий отчет'/>
                <q-tab  slot="title" name="tab-2" icon="fas fa-ruble-sign" label='Долги' />
 
                <!-- Targets -->
                <q-tab-pane name="tab-1">

                    <main-report/>

                </q-tab-pane>

                <q-tab-pane name="tab-2">

                    <debitReport/>

                </q-tab-pane>
            </q-tabs>
        </div>

    </div>
</template>

<script>
/* eslint-disable */


export default {
    
    name : 'reports',

    components : {
        mainReport : () => import('./mainReport.vue'),
        debitReport : () => import('./../debit/debit.vue'),
    },

    data() {
        return {
        }
    },
    
    created() {
    },

    computed : {
    },

    methods : {
        exportExcel() {
            console.log('export');
        }
    }

}
</script>

<style lang="scss" scoped>

</style>
